import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';

import { useAppSelector } from '@/redux';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

const HeaderMobile = dynamic(() => import('@/components/layout/header/HeaderMobile'));
HeaderMobile.displayName = 'HeaderMobile';
const HeaderDesktop = dynamic(() => import('@/components/layout/header/HeaderDesktop'));
HeaderDesktop.displayName = 'HeaderDesktop';

export const Header = ({ logo, backgroundColor, headerType }) => {
  const { storeConf } = useAppSelector(({ root }) => root);
  const { isMobileOrTablet } = useScreenSizeContext();

  return isMobileOrTablet ? (
    <HeaderMobile storeConf={storeConf} logo={logo} backgroundColor={backgroundColor} headerType={headerType} />
  ) : (
    <HeaderDesktop storeConf={storeConf} logo={logo} backgroundColor={backgroundColor} headerType={headerType} />
  );
};

Header.propTypes = {
  logo: PropTypes.string,
  backgroundColor: PropTypes.string,
  headerType: PropTypes.string
};

export default Header;
